import { render, staticRenderFns } from "./ServicedGalleryThumbnail.vue?vue&type=template&id=0ae396b4"
import script from "./ServicedGalleryThumbnail.vue?vue&type=script&lang=ts"
export * from "./ServicedGalleryThumbnail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports